import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, MenuMain, MenuType } from '../';
import cx from 'classnames';
import { IDivMainProps } from '../../interfaces';
import Styles from './m_styles.less';

export const MenuHorizontal: React.FC<IDivMainProps> = observer(({ className }: IDivMainProps) => {
    return (
        <Catcher>
            <div className={cx(className, Styles.main)}>
                <MenuMain menuType={MenuType.HORIZONTAL} />
            </div>
        </Catcher>
    );
});
